export const PRESET_SIZES = {
	lg: { w: 512, h: 512 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = ['bronze_case', 'silver_case', 'gold_case'] as const;
